// extracted by mini-css-extract-plugin
module.exports = {"root":"AppLayout_root__18utg"};